import React, { useContext, useMemo } from 'react';
import {
    DocumentPreviewProvider,
    DocumentProvider,
    DossierFormulaireProvider,
    DossierRoutingProvider,
    dossiersBasePath,
    Layout,
    LAYOUT_DEFAULT,
    LAYOUT_DOCUMENTS,
    LAYOUT_DOCUMENTS_1_3,
    LAYOUT_DOCUMENTS_FULL,
    SelectedDossierContext,
    useDefaultContextActions,
} from '@europrocurement/l2d-modules';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import { DossierInfoBodyValidation } from '../../components';

import { ordersBasePath } from '../../../Orders';

const getLayout = (): Layout => {
    const layouts = [LAYOUT_DEFAULT, LAYOUT_DOCUMENTS, LAYOUT_DOCUMENTS_FULL, LAYOUT_DOCUMENTS_1_3];
    const params = new URLSearchParams(document.location.search);

    if (params.has('layout') && layouts.includes(params.get('layout') as string)) {
        return params.get('layout') as Layout;
    }

    return LAYOUT_DEFAULT;
};

const DossierInfoValidation: React.FunctionComponent = function () {
    const layout = getLayout();
    const { dossier, siblings } = useContext(SelectedDossierContext);
    const siblingIds = useMemo(() => siblings.map((sibling) => sibling.id), [siblings]);
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);

    if (!dossier.id) {
        return null;
    }

    return (
        <DossierRoutingProvider
            orderBasePath={ordersBasePath}
            dossierBasePath={dossiersBasePath}
        >
            <DossierFormulaireProvider idDossiers={siblingIds as number[]}>
                <DocumentProvider idDossiers={siblingIds as number[]}>
                    <DocumentPreviewProvider>
                        <DossierInfoBodyValidation layout={layout} />
                    </DocumentPreviewProvider>
                </DocumentProvider>
            </DossierFormulaireProvider>
        </DossierRoutingProvider>
    );
};

export default DossierInfoValidation;
